import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'notification'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Új értesítés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Értesítések törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',
            ['date' + N + 'Format']: ({ dateText = '' }) => {
                if (!dateText) {
                    return dateText
                }
                try {
                    return new Date(dateText).toLocaleString('hu-HU')
                } catch (e) {
                }
                return dateText
            },

            [n + 'PopupClose']: 'Bezárás'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Értesítések',
            ['my' + Ns + 'Menu']: 'Értesítéseim',
            ['new' + N + 'Menu']: 'Új értesítés',
            [ns + 'Menu']: 'Értesítések',
            ['deleted' + Ns + 'Menu']: 'Törölt értesítések',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt értesítések',
            ['protection' + Ns + 'Menu']: 'Védett értesítések',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Az értesítés mentésre került',
            ['save' + N + 'SuccessMessage']: 'Az értesítés mentésre került',
            ['delete' + N + 'Success']: 'Az értesítés törölve lett',
            ['delete' + Ns + 'Success']: 'Az értesítések törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli az értesítést?',
            ['delete' + Ns + 'Question']: 'Biztosan törli az értesítéseket?',
            ['ban' + N + 'Success']: 'Az értesítés véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy az értesítést véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'Az értesítés jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod az értesítést',
            ['protection' + N + 'Success']: 'Az értesítés védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd az értesítést?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek értesítések'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Értesítés',
            [ns + 'Title']: 'Értesítések',
            ['new' + N + 'Title']: 'Új értesítés',
            ['edit' + N + 'Title']: 'Értesítés szerkesztése',
            ['user' + Ns + 'Title']: 'Értesítések',
            ['userDeleted' + Ns + 'Title']: 'Törölt értesítések',
            ['my' + Ns + 'Title']: 'Értesítéseim',
            ['myDeleted' + Ns + 'Title']: 'Törölt értesítéseim',

            ['dialogDelete' + N + 'Title']: 'Értesítés törlése',
            ['dialogBan' + N + 'Title']: 'Értesítés törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Értesítés jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Értesítés védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Értesítés védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Értesítések törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt értesítések',
            ['deleted' + Ns + 'Title']: 'Törölt értesítések',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett értesítések',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Értesítések kiválasztása',
            ['select' + N]: 'Értesítés kiválasztása'
        }
    }
}
